<template>
  <div :class="{'container-manage': !isMenuMiniSize, 'container-manage-thin-menu': isMenuMiniSize}">
    <!-- ヘッダー -->
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Data</b></p>
        <router-link 
          to="/client/manage" 
          style="margin-left: 25px; font-size:16px; color: #666; text-decoration: none; cursor: pointer; transition: all 0.2s; margin-top: 8px;"
          onmouseover="this.style.color='#333'; this.style.textDecoration='underline'" 
          onmouseout="this.style.color='#666'; this.style.textDecoration='none'"
        >
          応募者管理画面
        </router-link>
        <template v-if="user.isAgent || user.permission === 0">
          <span style="margin: 0 10px; color: #ccc; margin-top: 8px;">／</span>
          <router-link 
            to="/client/report" 
            style="font-size:16px; color: #666; text-decoration: none; cursor: pointer; transition: all 0.2s; margin-top: 8px;"
            onmouseover="this.style.color='#333'; this.style.textDecoration='underline'" 
            onmouseout="this.style.color='#666'; this.style.textDecoration='none'"
          >
            レポーティング
          </router-link>
        </template>
        <span style="margin: 0 10px; color: #ccc; margin-top: 8px;">／</span>
        <p style="font-size:16px; color: #666; margin-top: 8px;">ロボの稼働状況</p>
      </div>
    </div>
    
    <!-- パフォーマンス画面本体 -->
    <PerformanceView 
      :isEmbedded="true"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PerformanceView from '@/views/DashBoard/Performance/PerformanceView'

export default {
  name: 'RobotPerformanceMainView',
  components: {
    PerformanceView
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState("setting", ["isMenuMiniSize"])
  },
  created() {
    // Virtual Office接続処理
    if (this.user && this.user.companyID && this.user.userHash) {
      const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
      this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
      const con = {
        'is_connect': true
      }
      this.$store.dispatch('auth/setUserConnect', con)
    }
  }
}
</script>

<style lang="scss" scoped>
.container-manage {
  height: 100vh;
  width: calc(100% - 200px);
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.container-manage-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.header-box {
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
  
  .header-menu {
    display: flex;
    align-items: center;
    
    p {
      margin: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/RobotPerformance/RobotPerformanceMainView.vue